import { Spacer } from '@dot/design-system';
import { useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import CancelledIcon from '@/assets/icons/mobile-redirect-cancelled.svg?react';
import * as GSC from '@/styles/GlobalStyles';
import { fontHeadingOne, fontTextMdRegular } from '@/styles/helpers';

const ContainerSC = styled.div`
  max-width: 90%;
  margin-inline: auto;
  text-align: center;
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
`;

const TitleSC = styled.h1`
  ${fontHeadingOne};
`;

const TextSC = styled.p`
  ${fontTextMdRegular};
`;

const IconWrapperSC = styled.div`
  display: flex;
  justify-content: center;
`;

export const MobileRedirectCanceled = () => {
  const { t } = useTranslation();

  return (
    <GSC.FadeInContainer>
      <ContainerSC>
        <Spacer $bottom={2} $top={2}>
          <IconWrapperSC>
            <CancelledIcon />
          </IconWrapperSC>
        </Spacer>
        <Spacer $bottom={0.75}>
          <TitleSC id="mobile-redirect-cancelled-title">{t('steps.mobileRedirect.canceled.title')}</TitleSC>
        </Spacer>
        <TextSC id="mobile-redirect-cancelled-subtitle">{t('steps.mobileRedirect.canceled.subtitle')}</TextSC>
      </ContainerSC>
    </GSC.FadeInContainer>
  );
};
